// extracted by mini-css-extract-plugin
module.exports = {"imgUrl":"PayModal_imgUrl__kz_Vo"};